module.exports = __webpack_public_path__ + "img/fc.711053b5.svg";